import { SVGInterface } from "../../interface";

const ArrowSolidDown = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path d="M7 9.5L12 14.5L17 9.5H7Z" fill={color || "#0E171F"} />
  </svg>
);

export default ArrowSolidDown;
